import { Skeleton } from "src/components/Skeleton/Skeleton";
import styled from "styled-components";
import color, { primitive } from "src/design-system/tokens/color";
import { spacing } from "src/design-system/tokens/spacing";
import { useScreenMinWidth } from "src/utils/hooks/useScreenMinWidth";
import { ListCardDesktopLoading } from "./Cards/ListCardDesktopLoading";
import { ListCardMobileLoading } from "./Cards/ListCardMobileLoading";

export default function HotelsScreenLoading() {
  const { isMobile } = useScreenMinWidth();

  return (
    <>
      {isMobile ? (
        <>
          <MobileSearch>
            <BlockWhite />
            <Skeleton height={32} />
          </MobileSearch>
          <LoadingHotels />
        </>
      ) : (
        <>
          <DesktopSearch>
            <Skeleton height={36} width={220} />
          </DesktopSearch>
          <DesktopBody>
            <LoadingHotels />
          </DesktopBody>
        </>
      )}
    </>
  );
}

const DesktopSearch = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.xl};
`;

const MobileSearch = styled.div`
  margin-top: 69px;
  min-height: 94px;
  padding: 10px 16px;
  background-color: ${color.bg.fill.solid};
  box-shadow: 0px ${spacing.sm} ${spacing.sm} ${primitive.neutral_1600 + "22"};
`;
const BlockWhite = styled.div`
  background-color: white;
  min-height: 42px;
`;

const DesktopBody = styled.div`
  background-color: ${color.bg.fill.solidHover};
`;

export function LoadingHotels() {
  const { isMobile } = useScreenMinWidth();
  const Component = isMobile ? ListCardMobileLoading : ListCardDesktopLoading;

  return (
    <HotelListWrapper>
      {Array(12)
        .fill(undefined)
        .map((_, i) => (
          <Component key={i} />
        ))}
    </HotelListWrapper>
  );
}

const HotelListWrapper = styled.ol`
  display: flex;
  flex-direction: column;
  padding: ${spacing.xl} 0;
  gap: ${spacing.xl};
  background-color: ${color.bg.surface.active};
`;
